import * as Sentry from '@sentry/react'

const PII_FIELDS = [
  // Identity
  'ssn',
  'socialsecuritynumber',
  'firstname',
  'lastname',
  'fullname',
  'legalname',
  // Date of birth — covers dateOfBirth, birthdate, birthday, dob
  'dateofbirth',
  'birthdate',
  'birthday',
  'dob',
  // Contact
  'phone',
  'password',
  'email',
  'emailaddress',
  // Address
  'address',
  'streetaddress',
  // Financial — account & routing
  'accountnumber',
  'routingnumber',
  'bankaccount',
  // Payment card
  'cardnumber',
  'cvv',
  'cvc',
  'creditcard',
  'expiry',
  'expirationdate',
  'cardexpiry',
  'exp',
  // Tokens / secrets
  'token',
]

function scrubPii(data) {
  if (typeof data !== 'object' || data === null) return data
  const result = Array.isArray(data) ? [...data] : { ...data }
  for (const key of Object.keys(result)) {
    if (PII_FIELDS.some(field => key.toLowerCase().includes(field))) {
      result[key] = '[Filtered]'
    } else if (typeof result[key] === 'object') {
      result[key] = scrubPii(result[key])
    }
  }
  return result
}

export function initSentry() {
  if (process.env.REACT_APP_SENTRY_ENABLED !== 'true') return

  const dsn = process.env.REACT_APP_SENTRY_DSN
  if (!dsn) {
    return
  }

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    // Performance tracing disabled — error monitoring only
    tracesSampleRate: 0,
    integrations: [
      // Capture explicit console.error calls only
      Sentry.consoleLoggingIntegration({ levels: ["error"] }),
    ],
    // Enable logs to be sent to Sentry
    enableLogs: true,
    beforeSend(e) {
      if (e.request && e.request.data) {
        e.request.data = scrubPii(e.request.data)
      }
      if (e.extra) {
        e.extra = scrubPii(e.extra)
      }
      return e
    },
    beforeSendLog(log) {
      // Drop React internal warnings that come through as Sentry logs
      if (log.message && log.message.startsWith('Warning:')) return null
      return log
    },
    beforeBreadcrumb(breadcrumb) {
      // Drop React internal warnings (prop-types, lifecycle deprecations) that
      // console.error emits — these are not actionable app errors
      if (breadcrumb.category === 'console' && breadcrumb.message?.startsWith('Warning:')) {
        return null
      }
      return breadcrumb
    },
  })

  // Capture the initial landing page
  Sentry.addBreadcrumb({
    category: 'navigation',
    message: window.location.pathname + window.location.search,
    level: 'info',
    data: { referrer: document.referrer || 'direct' },
  })
}

export { Sentry }
